import styled, { css } from 'styled-components'

interface PropsListItem {
  isAction: boolean;
}

export const ListItem = styled.li<PropsListItem>`
  display: flex;
  align-items: center;
  list-style: none;
  ${props => props.theme.list}

  ${props => props.theme.motion}
  transition-property: background, color;

  ${props => props.isAction && css`
    cursor: pointer;
    &:hover {
      ${props => props.theme.states.hover.list}
      /* @media(min-width: 768px) {
        ${props => props.theme.list.tablet}
      } */
      span {
        color: currentColor;
      }
    }
  `}

  &:focus-visible,
  &:focus{
    // Add custom focus styles here
  }

  .tmp-list-item__leading-icon {
    ${props => props.theme.leadingIcon}
  }

  .tmp-list-item__trailing-icon {
    margin-left: auto;
    ${props => props.theme.trailingIcon}
  }
`;


export const ListContent = styled.div`
  display: flex;
  flex-direction: column;
`
interface PropsListLabel {
  type: string;
}

export const ListLabel = styled.span<PropsListLabel>`
  ${props => props.theme.label[props.type]}
  @media(min-width: 768px) {
    ${ props => props.theme.label[props.type].tablet }
  }
`

export const ListText = styled.span`
  ${props => props.theme.text}
  margin-top: 6px;
`
